import { frozen } from "mobx-keystone";
import { Cubby } from "../stores/Cubby";

export const updateBoltElevenUserInvoices = (cubby: Cubby, invoices: any[]) => {
  console.log(
    "lastProposedBolt11InvoiceUuid",
    cubby.lastProposedBolt11InvoiceUuid
  );
  for (const invoice of invoices) {
    const uuid = invoice.input_data.uuid;
    //console.log("looking at uuid", uuid);
    if (uuid == cubby.lastProposedBolt11InvoiceUuid) {
      cubby.setLastBolt11UserGeneratedPayRequest(invoice.pay_request);
    }
    cubby.userBoltElevenInvoices = frozen(invoices);
  }
};
